import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { resetJourney } from '@/store/reset';

export interface ShippingDetailsState {
  childName: string;
  postalRewards: boolean;
  useBillingAddress: boolean;
  address1: string;
  address2: string;
  address3: string;
  town: string;
  postcode: string;
  country: string;
}

const initialState: Readonly<ShippingDetailsState> = {
  childName: '',
  postalRewards: true,
  useBillingAddress: false,
  address1: '',
  address2: '',
  address3: '',
  town: '',
  postcode: '',
  country: 'GB',
};

export const shippingDetailsSlice = createSlice({
  name: 'shippingDetails',
  initialState,
  reducers: {
    updateShippingDetailsFields(state: ShippingDetailsState, action: PayloadAction<Partial<ShippingDetailsState>>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setPostalRewards(state: ShippingDetailsState, action: PayloadAction<boolean>) {
      return {
        ...state,
        postalRewards: action.payload,
      };
    },
    setUseBillingAddress(state: ShippingDetailsState, action: PayloadAction<boolean>) {
      return {
        ...state,
        useBillingAddress: action.payload,
      };
    },
  },
  extraReducers: builder => builder.addCase(resetJourney, () => initialState),
});

export const {
  updateShippingDetailsFields,
  setPostalRewards,
  setUseBillingAddress,
} = shippingDetailsSlice.actions;

export default shippingDetailsSlice.reducer;
